import axios from 'axios';
import { MEMBERSHIP_PRICE, LOCATION_URL } from '../constants';
export const getMembershipPrice = async (data) => {

    let hotelBusinessCategory;
    let countryCode;
    switch(data){
        case("CN"):
        case("MO"):
        countryCode = "HK";
        break;
        default:
        countryCode = data;
    };

    try {
        const response = await axios.get(`${LOCATION_URL}=${countryCode}`)
        const hotelSalesData = response.data.hotelSalesData
        const regionData = hotelSalesData.map(salesData => salesData.country.toUpperCase());
        
        const country = regionData.includes(countryCode) ? countryCode : "EN";
        const priceResponse = await fetchPriceResponse(country);

        hotelBusinessCategory = { business_category: response?.data?.hotelSalesDefaultBC || "24" };

        return [priceResponse, hotelBusinessCategory];

    } catch (err) {
        console.log("Country is part of ROW");
        hotelBusinessCategory = { business_category: "24" };
        const priceResponse = await fetchPriceResponse("EN")
        return  [priceResponse, hotelBusinessCategory];
    }
};

const fetchPriceResponse = async (data)=> {
    try {
        const priceResponse = await axios.post(MEMBERSHIP_PRICE, {
            country: data
        })
        const membershipData = priceResponse.data
        if(membershipData.statusCode === 500){
            return null
        } else {
            return membershipData
        }
        // console.log(membershipData)
        // return membershipData
    } catch(err){
        console.log("Price not available", err);
        return null;
    }
}